import {
	HttpErrorResponse,
	HttpEvent,
	HttpHandler,
	HttpInterceptor,
	HttpRequest,
	HttpResponse
} from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { KeepAliveService } from './keep-alive.service';
import { environment } from 'environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { SessionService } from './session.service';
import {tap} from 'rxjs/operators'

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
	private debug: boolean = false;
	private isRedirecting = false;
	private keepAlive: KeepAliveService;
	private session: SessionService;	
	constructor(
		private router: Router,
		// , private keepAlive: KeepAliveService
		inj: Injector,
		// , private http: HttpClient
		private cookie: CookieService
	) {
		setTimeout(() => {
			this.session = inj.get(SessionService);
			this.keepAlive = inj.get(KeepAliveService);
		});
	}

	intercept(
		req: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		return next.handle(req).pipe(tap(
			(event: HttpEvent<any>) => {
				// console.log('AuthInterceptor.intercept()');
				if (event instanceof HttpResponse) {
					// It is assumed that token has been touched and
					// its TTL has been reset to 10 minutes.
					this.keepAlive.touchSessionTimeout();
				}
			},
			(err: any) => {
				if (err instanceof HttpErrorResponse) {
					if (err.status === 401 && !environment.DISABLE_AUTH) {
						// redirect to logout page (if we're not there already)
						if (this.debug) { console.log("Intercepted 401...", this.router.url); }
						if (this.router.url !== 'logout/true' && this.router.url !== 'logout/all' && !this.isRedirecting) {
							if (this.cookie.get('IsAuthorized') === 'agent') {
								this.isRedirecting = true;
								if (this.debug) { console.log("navigating to logout all", this.isRedirecting); }
								this.router.navigate(['logout/all']).then(r => {
									this.isRedirecting = false;
									if (this.debug) { console.log("finished navigating to logout", this.isRedirecting); }
								});
							} else {
								this.isRedirecting = true;
								if (this.debug) { console.log("navigating to logout true", this.isRedirecting); }
								this.session.logout(this.isRedirecting);								
								// this.router.navigate(['logout/true']).then(r => {
								// 	this.isRedirecting = false;
								// 	if (this.debug) { console.log("finished navigating to logout", this.isRedirecting); }
								// });
							}
						}
					}
					if (err.status >= 500) {
						if (this.debug) { console.log('Status ' + err.status); }
					}
				}
			}
		));
	}

	// // intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
	// // 	const started = Date.now();
	// // 	return next.handle(req).do((event: HttpEvent<any>) => {
	// // 		if (event instanceof HttpResponse) {
	// // 			const elapsed = Date.now() - started;
	// // 			console.log(`Request for ${req.urlWithParams} took ${elapsed} ms.`);
	// // 		}
	// // 	}, (err: any) => {
	// // 		if (err instanceof HttpErrorResponse) {
	// // 			const elapsed = Date.now() - started;
	// // 			console.log(`Request for ${req.urlWithParams} failed after ${elapsed} ms.`);
	// // 		}
	// // 	});
	// // }
}
